import React from "react";
import "./Aboutbanner.css";

function AboutBanner() {
  return (
    <div className="about-page">
      <div className="about-banner">
        <div className="banner-left">
          <h1>About Us</h1>
          <p>
            PennyTree is a digital bank built to make everyday banking simple,
            secure, and accessible. We are powered by Penn Microfinance Bank,
            licensed by the Central Bank of Nigeria, and authorized by the
            Securities and Exchange Commission to operate a crowdfunding
            platform. This gives us the unique ability to offer both core
            financial services and access to capital for individuals and
            businesses.<br/> <br/> With PennyTree, you can send money, pay bills, save
            toward personal goals, or run your business with ease. Business
            owners can open an account in minutes, generate account numbers from
            any bank of their choice, receive payments, issue invoices and
            receipts, download stamped bank statements and so. much more. For
            those who shop, advertise, or subscribe online, our virtual dollar
            card makes global payments effortless.<br/> <br/> Beyond banking, we connect
            entrepreneurs, creators, and small businesses to people who believe
            in what they are building. Through our crowdfunding platform, we
            make it easier for bold ideas to find support and for everyday
            people to participate in meaningful growth.<br/> <br/> PennyTree is more than a
            bank, it's a financial ecosystem.
          </p>
        </div>
        <div className="banner-right">
          <img src="/assets/IMG_7669 1.png" alt="" />
        </div>
      </div>
      {/* <div className="vis-mission">
        <div className="vis-mis-box">
            <div className="half-circle">
            <div className="half-circle-box">
            <img src="https://res.cloudinary.com/teb/image/upload/v1671133920/binocular_1_wkbdux.png" alt="" />
            </div>
            </div>
            <h1>Our Vision</h1>
            <p>To make humanity seamless through finance.</p>
            <div className="green-line"></div>
        </div>
        <div className="vis-mis-box">
            <div className="half-circle">
            <div className="half-circle-box">
            <img src="https://res.cloudinary.com/teb/image/upload/v1671133920/target-2_1_x95p2d.png" alt="" />
            </div>
            </div>
            <h1>Our Mission</h1>
            <p>We are integrating finance and lifestyle as one-component.</p>
            <div className="green-line"></div>
        </div>
    </div> */}
      {/* <div className="core-values">
        <h1>Our Core Values</h1>
        <img src="https://res.cloudinary.com/teb/image/upload/v1671004943/Handdrawn_vector_fvblaz.png" alt="" />
        <div className="core-values-container">
            <div className="core-values-box">
            <div className="core-values-header">
                <div className="green-dot"></div>
                <p>Service excellence</p>
            </div>
            <h3>We provide premium value and service by ensuring our work is up to par.</h3>
            </div>
            <div className="core-values-box">
            <div className="core-values-header">
                <div className="green-dot"></div>
                <p>People Centric</p>
            </div>
            <h3>It starts with us; We honor commitments to our customers and to one another.</h3>
            </div>
            <div className="core-values-box">
            <div className="core-values-header">
                <div className="green-dot"></div>
                <p>Innovation</p>
            </div>
            <h3>Innovation is the core value on which the PennyTree App is built. </h3>
            </div>
        </div>
    </div> */}
      <div className="ceo">
        <div className="ceo-left">
          <h1>Directors' Statement</h1>
          <h4>Committed to building the future of retail banking for you</h4>
          <p>
            Just like you, we are familiar with the challenges of personal and
            business banking and are committed to making the experience simpler
            for you.
          </p>
          <p>
            We are building the future of retail banking to give you a
            dependable platform where you can save or invest your money
            securely, create a bank account for your business, and access the
            needed advisory services while collaborating with entrepreneurs in
            our community to achieve business growth. We are a regulated and
            licensed financial technology platform, empowered to provide the
            best financial services for you both as an individual and a business
            owner in the most simple and easily accessible way.
          </p>
          <p>
            Come on this journey with us as we build the future of retail
            banking designed for you.
          </p>
        </div>
        <div className="ceo-right">
          <img src="/assets/Mask group.png" alt="" />
        </div>
      </div>
    </div>
  );
}

export default AboutBanner;
